/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui';
import { hoverTransition, aniSpeed } from '../../utils/styles/general';



/* ++++++++++ --------------- CONTENT SCROLLER : STYLES --------------- ++++++++++ */
export default {
    contentscroller: {
        display: 'flex',
        alignItems: 'center'
    }
};
